export const AuthConstants = {
  LOGIN: "AUTH_LOGIN",
  LOGOUT: "AUTH_LOGOUT",
  ME: "AUTH_PROFILE",
  FAILED: "AUTH_FAILED",
  AUTH: "CHECK_USER_AUTH",
  CLEAR: "AUTH_CLEAR",
};

export const CourseConstants = {
  ALL: "GET_ALL_COURSES",
  FEATURED: "GET_FEATURED_COURSES",
  MY_COURSES: "GET_USER_COURSES",
  MY_COURSE_DETAIILS: "GET_USER_COURSE_DETAILS",
  GET: "GET_COURSE",
  BUY_COURSE: "BUY_COURSE",
  FAILED: "COURSE_FAILED",
};

export const TopicConstants = {
  GET: "GET_TOPIC_DETAILS",
  FAILED: "TOPIC_FAILED",
  CLEAR: "TOPIC_CLEAR",
};

export const UserAnswerConstants = {
  STORE_OR_UPDATE_MULTIPLE: "STORE_OR_UPDATE_MULTIPLE",
  CHECK_USER_PROGRESS: "CHECK_USER_PROGRESS",
  FAILED: "FAILED",
  LOADING: "LOADING",
};

export const DownloadCertificate = {
  DOWNLOAD_CERTIFICATE: "DOWNLOAD_CERTIFICATE",
  FAILED: "FAILED",
  DOWNLOAD_LOADING: "DOWNLOAD_LOADING",
};

export const CheckCertificate = {
  CHECK_CERTIFICATE: "CHECK_CERTIFICATE",
  FAILED: "FAILED",
  LOADING: "LOADING",
};

export const CourseProgress = {
  COURSE_PROGRESS_LOADING: "COURSE_PROGRESS_LOADING",
  COURSE_PROGRESS_FAILED: "COURSE_PROGRESS_FAILED",
  COURSE_PROGRESS: "COURSE_PROGRESS",
};

export const RESET_MY_COURSE = "RESET_MY_COURSE";

export const Dashboard = {
  DASHBOARD_LOADING: "DASHBOARD_LOADING",
  DASHBOARD_FAILED: "DASHBOARD_FAILED",
  DASHBOARD_SUCCESS: "DASHBOARD_SUCCESS",
};

export const QuizResult = {
  QUIZRESULT_FAILED: "QUIZRESULT_FAILED",
  QUIZRESULT_SUCCESS: "QUIZRESULT_SUCCESS",
};

export const Transactions = {
  TRANSACTIONS_FAILED: "TRANSACTIONS_FAILED",
  TRANSACTIONS_SUCCESS: "TRANSACTIONS_SUCCESS",
};

export const UpdateUser = {
  UPDATE_FAILED: "UPDATE_FAILED",
  UPDATE_SUCCESS: "UPDATE_SUCCESS",
};

export const addReview = {
  ADD_REVIEW_FAILED: "ADD_REVIEW_FAILED",
  ADD_REVIEW_SUCCESS: "ADD_REVIEW_SUCCESS",
};

export const Certificates = {
  CERTIFICATE_FAILED: "CERTIFICATE_FAILED",
  CERTIFICATE_SUCCESS: "CERTIFICATE_SUCCESS",
};
